import React, { Component } from "react";

class Counter extends Component {
  render() {
    return (
      <div className="d-block card mt-2 shadow p-2 mb-4 bg-light border-0 row">
        {/*this.props.children*/}
        <span className={this.getBadgeClasses()}>{this.formatCount()}</span>
        <button
          onClick={
            /*we use arrow fun to pass parameters*/ () =>
              this.props.onIncrement(this.props.counter)
          }
          className="btn btn-success btn-sm"
        >
          +
        </button>

        <button
          onClick={
            /*we use arrow fun to pass parameters*/ () =>
              this.props.onRemove(this.props.counter)
          }
          className="btn btn-secondary btn-sm m-2"
        >
          -
        </button>

        <button
          onClick={
            /*we use arrow fun to pass parameters*/ () =>
              this.props.onDelete(this.props.counter.id)
          }
          className="btn btn-danger btn-sm m-2 float-right"
        >
          x
        </button>
      </div>
    );
  }

  //a function for getting the style classes of the counter
  getBadgeClasses() {
    let classes = "badge m-2 badge";
    classes += this.props.counter.value === 0 ? "-warning" : "-primary";
    return classes;
  }

  //a function for formatting the counter value
  formatCount() {
    //destructing
    const { value: count } = this.props.counter;
    return count === 0 ? "0" : count;
  }
}

export default Counter;
